import { App } from './app'
import 'firebase/compat/functions'

/** Must match deployed callable region (`firebase functions:list` → Location). */
export const functions = App.functions('us-central1')
